import { render, staticRenderFns } from "./tabla-abonos-cobros.vue?vue&type=template&id=9ccdc3f2&scoped=true"
import script from "./tabla-abonos-cobros.vue?vue&type=script&lang=js"
export * from "./tabla-abonos-cobros.vue?vue&type=script&lang=js"
import style0 from "./tabla-abonos-cobros.vue?vue&type=style&index=0&id=9ccdc3f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ccdc3f2",
  null
  
)

export default component.exports